import { Flex, Input, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import {
  createWorkIdea,
  getWorkIdeaDetail,
  updateWorkIdea,
} from '../../../api/aposWorkIdea.api'
import ColorSelector from '../../../components/apos/ColorSelector'
import EmojiDropDown from '../../../components/apos/EmojiDropDown'
import AopsCommonModalLayout from '../../../components/apos/modal/AopsCommonModalLayout'
import { userState } from '../../../store/user'

const { TextArea } = Input

const WorkIdeaFormModal = ({
  open,
  onClose,
  initialData = null,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    title: '',
    memo: '',
    colorCode: '#FFECEC', // default color
    emoji: '😊', // default emoji
  })
  const [user] = useRecoilState(userState)

  useEffect(() => {
    if (open) {
      if (initialData?.id) {
        // Read: 상세 조회로 최신 데이터 가져오기
        fetchWorkIdeaDetail(initialData.id)
      } else {
        setFormData({
          title: '',
          memo: '',
          colorCode: '#FFECEC',
          emoji: '😊',
        })
      }
    }
  }, [open, initialData])

  const fetchWorkIdeaDetail = async (ideaId) => {
    try {
      const res = await getWorkIdeaDetail(ideaId)
      // console.log('🐲fetchWorkIdeaDetail res', res)
      if (res?.data) {
        setFormData({
          title: res.data.title || '',
          memo: res.data.memo || '',
          colorCode: res.data.colorCode || '#FFECEC',
          emoji: res.data.emoji || '😊',
        })
      }
    } catch (error) {
      console.error('생각노트 조회 실패:', error)
      // 조회 실패 시 initialData 사용
      setFormData({
        title: initialData?.title || '',
        memo: initialData?.memo || '',
        colorCode: initialData?.colorCode || '#FFECEC',
        emoji: initialData?.emoji || '😊',
      })
    }
  }

  const handleSubmit = async () => {
    if (!formData.title.trim()) {
      message.error('아이디어 명을 입력해주세요')
      return
    }
    if (formData.title.length > 100) {
      message.error('아이디어 명은 100자 이내로 입력해주세요')
      return
    }
    if (formData.memo.length > 300) {
      message.error('메모는 300자 이내로 입력해주세요')
      return
    }

    try {
      setLoading(true)

      if (initialData?.id) {
        // Update: 수정
        const params = {
          workIdeaId: initialData.id,
          title: formData.title,
          memo: formData.memo,
          salusUserId: user.id,
          colorCode: formData.colorCode,
          emoji: formData.emoji,
        }
        console.log('🐲updateWorkIdea params', params)
        const res = await updateWorkIdea(params)
        console.log('🐲updateWorkIdea res', res)
        if (res.status === 200) {
          message.success('생각노트가 수정되었습니다.')
        } else {
          message.error(
            '생각노트 수정에 실패했습니다. 잠시 후 다시 시도해주세요.',
          )
        }
      } else {
        // Create: 생성
        const params = {
          title: formData.title,
          memo: formData.memo,
          salusUserId: user.id,
          colorCode: formData.colorCode,
          emoji: formData.emoji,
        }
        // console.log('params', params)
        const res = await createWorkIdea(params)
        // console.log('🐲createWorkIdea res', res)
        if (res.status === 200) {
          message.success('생각노트가 생성되었습니다.')
        }
      }

      onSuccess?.()
      onClose()
    } catch (error) {
      console.error('생각노트 저장 실패:', error)
      message.error('생각노트 저장에 실패했습니다. 잠시 후 다시 시도해주세요.')
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => onClose()

  const isFormValid =
    formData.title.trim().length > 1 && formData.memo.trim().length > 1

  return (
    <AopsCommonModalLayout
      title={initialData ? '내 생각노트' : '생각 적어보기'}
      onClose={handleCancel}
      open={open}
    >
      <div className="form-container work-idea-modal">
        <div className="form-wrapper">
          {/* 아이디어 명 */}
          <div
            className="form-section"
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <label
              className="form-label"
              style={{ marginBottom: '8px', width: '100%' }}
            >
              생각한 아이디어 명
            </label>
            <Flex gap="8px" style={{ width: '100%' }}>
              <EmojiDropDown
                value={formData.emoji}
                defaultValue={formData.emoji}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, emoji: value }))
                }
              />
              <Input
                placeholder="어떤 생각을 하셨나요?"
                className="form-input"
                value={formData.title}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, title: e.target.value }))
                }
                maxLength={100}
                style={{
                  width: '100%',
                  fontSize: '16px',
                  fontWeight: '600',
                  letterSpacing: '-0.56px',
                }}
              />
            </Flex>
          </div>

          {/* 메모 */}
          <div
            className="form-section"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <label className="form-label">메모</label>
            <TextArea
              rows={7}
              placeholder="생각에 대한 메모를 적어보세요"
              showCount
              maxLength={300}
              value={formData.memo}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, memo: e.target.value }))
              }
              className="form-input"
            />
          </div>

          {/* 메모장 컬러 */}
          <div
            className="form-section"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <Flex align="center">
              <label className="form-label">메모장 컬러</label>
              <ColorSelector
                value={formData.colorCode}
                defaultValue={formData.colorCode}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, colorCode: value }))
                }
              />
            </Flex>
          </div>
        </div>
      </div>

      <div className="popup-footer">
        <button
          className="btn-cancel"
          onClick={handleCancel}
          disabled={loading}
        >
          취소
        </button>
        <button
          className="btn-submit"
          onClick={handleSubmit}
          disabled={loading || !isFormValid}
        >
          {initialData?.id ? '수정하기' : '등록'}
        </button>
      </div>
    </AopsCommonModalLayout>
  )
}

export default WorkIdeaFormModal
